/**
 * @fileoverview Application entry point.
 * @module main
 */

import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import { ErrorTemplate } from "@/components/templates"
import Router from "@/config/router"
import { ErrorBoundary, registerGlobalErrorHandlers } from "@/lib/errors"

import "@/styles/index.css"

// Catch-all for errors no boundary sees: event handlers, timers, floating
// promises. Installed before the first render so nothing slips through.
registerGlobalErrorHandlers()

const container = document.getElementById("root")

if (container === null) {
	throw new Error("Root container #root is missing from index.html")
}

createRoot(container).render(
	<StrictMode>
		<ErrorBoundary
			fallback={(error, reset) => (
				<ErrorTemplate error={error} onRetry={reset} />
			)}
		>
			<Router />
		</ErrorBoundary>
	</StrictMode>
)
